import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { getChinaLocalization } from 'shared/account/reducer';
import { T } from 'shared/helper/translate';
import featureEnabled from 'shared/helper/feature';
import { getPaddlePlanIdForCurrentPlan } from '../reducer';
import { PLAN_EXPIRATION } from '../constants';
import PlanManagementButton from '../plan/PlanManagementButton';
var RubriqNotificationBox = function RubriqNotificationBox() {
  var _curiePlans$premium;
  var curiePlan = useSelector(function (_ref) {
    var curie = _ref.curie;
    return curie.plan;
  });
  var curiePlans = useSelector(function (_ref2) {
    var curie = _ref2.curie;
    return curie.plans;
  });
  var planStatus = curiePlan.status,
    planType = curiePlan.planType;
  var isChinaUser = useSelector(getChinaLocalization);
  var paddleBillingForChina = featureEnabled('rubriq_china_also_uses_paddle');
  var useCartInsteadOfPaddle = isChinaUser && !paddleBillingForChina;
  var upgradeLink = useCartInsteadOfPaddle ? '/rubriq/plan/subscribe' : '/rubriq/plan/subscribe/premium';
  var hasCrossedExpirationThreshold = function hasCrossedExpirationThreshold() {
    return curiePlan.endsAt && moment(curiePlan.endsAt) <= moment().add(PLAN_EXPIRATION.REMAINING_THRESHOLD, 'd');
  };
  var isActiveCartPurchaseSub = curiePlan.receiptCode && planStatus === 'active';

  // Trial past-due: payment failed while still in the trial grace period.
  // Identified by trialGracePeriod === true on the premium plans object (confirmed via API data).
  var isTrialPastDue = (curiePlans === null || curiePlans === void 0 || (_curiePlans$premium = curiePlans.premium) === null || _curiePlans$premium === void 0 ? void 0 : _curiePlans$premium.trialGracePeriod) === true;
  var notification = function () {
    if (planType === 'premium') {
      if (planStatus === 'expired') {
        // Paddle past-due users whose plan expired due to failed payment should be prompted
        // to update their billing info rather than start a new subscription.
        if (!useCartInsteadOfPaddle && curiePlan.paddleSubscription) {
          return /*#__PURE__*/React.createElement(T.md, {
            inline: true,
            source: "curie.payment-failed-within-grace-period",
            linkRenderer: function linkRenderer(_ref3) {
              var _curiePlan$paddleSubs;
              var children = _ref3.children;
              return /*#__PURE__*/React.createElement(PlanManagementButton, {
                classicUrl: (_curiePlan$paddleSubs = curiePlan.paddleSubscription) === null || _curiePlan$paddleSubs === void 0 ? void 0 : _curiePlan$paddleSubs.updateUrl,
                targetAction: "update",
                paddlePlanId: useSelector(getPaddlePlanIdForCurrentPlan),
                asButton: false
              }, children);
            }
          });
        }
        return /*#__PURE__*/React.createElement(T.md, {
          inline: true,
          useLink: true,
          source: "curie.premium-expired-notification",
          params: {
            link: '/rubriq/plan/subscribe'
          }
        });
      }
      if (isActiveCartPurchaseSub && hasCrossedExpirationThreshold()) {
        return /*#__PURE__*/React.createElement(T.md, {
          inline: true,
          useLink: true,
          source: "curie.premium-to-be-expired-notification",
          params: {
            link: '/rubriq/plan/subscribe'
          }
        });
      }
      // Trial past-due: payment failed while in trial grace period.
      // User loses all access immediately — prompt to update billing info, not start a new sub.
      if (!useCartInsteadOfPaddle && planStatus === 'error' && isTrialPastDue) {
        return /*#__PURE__*/React.createElement(T.md, {
          inline: true,
          source: "curie.payment-failed-within-grace-period",
          linkRenderer: function linkRenderer(_ref4) {
            var _curiePlan$paddleSubs2;
            var children = _ref4.children;
            return /*#__PURE__*/React.createElement(PlanManagementButton, {
              classicUrl: (_curiePlan$paddleSubs2 = curiePlan.paddleSubscription) === null || _curiePlan$paddleSubs2 === void 0 ? void 0 : _curiePlan$paddleSubs2.updateUrl,
              targetAction: "update",
              paddlePlanId: useSelector(getPaddlePlanIdForCurrentPlan),
              asButton: false
            }, children);
          }
        });
      }
      if (!useCartInsteadOfPaddle && planStatus === 'error') {
        return /*#__PURE__*/React.createElement(T.md, {
          inline: true,
          source: "curie.payment-failed-within-grace-period",
          linkRenderer: function linkRenderer(_ref5) {
            var _curiePlan$paddleSubs3;
            var children = _ref5.children;
            return /*#__PURE__*/React.createElement(PlanManagementButton, {
              classicUrl: (_curiePlan$paddleSubs3 = curiePlan.paddleSubscription) === null || _curiePlan$paddleSubs3 === void 0 ? void 0 : _curiePlan$paddleSubs3.updateUrl,
              targetAction: "update",
              paddlePlanId: useSelector(getPaddlePlanIdForCurrentPlan),
              asButton: false
            }, children);
          }
        });
      }
    }
    if (planType === 'free_trial' && planStatus === 'expired') {
      return /*#__PURE__*/React.createElement(T.md, {
        inline: true,
        useLink: true,
        source: "curie.free-trial-expired",
        params: {
          upgradeLink: upgradeLink
        }
      });
    }
    if (curiePlan.status === 'error') {
      return /*#__PURE__*/React.createElement(T.md, {
        inline: true,
        useLink: true,
        source: "curie.failed-payment-message",
        params: {
          upgradeLink: upgradeLink
        }
      });
    }
    return null;
  }();
  return notification ? /*#__PURE__*/React.createElement("div", {
    className: "row mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alert alert-block alert-warning"
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-0"
  }, notification)))) : null;
};
export default RubriqNotificationBox;